import { observer } from 'mobx-react';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import Main from '../../BrowserSupport/Main';
import Notifications from '../../Notifications';
import I18nTitle from '../../Title/I18nTitle';
import MainNav from '../Platform/MainNav';
import Head from './Head';
import Nav from './Nav';

const Products: React.FC = () => (
  <>
    <I18nTitle title="Products" />
    <div className="min-h-screen">
      <MainNav />
      <Notifications />
      <div className="bg-white border-b-1 border-b-gray-200">
        <div className="max-w-clientPortalMaxWidth mx-auto w-full overflow-x-hidden">
          <div className="lg:px-12 px-2.5">
            <Head />
            <Nav />
          </div>
        </div>
      </div>
      <div className="max-w-clientPortalMaxWidth mx-auto">
        <Main id="main" className="min-h-[calc(100vh-150px)]">
          <Outlet />
        </Main>
      </div>
    </div>
  </>
);

export default observer(Products);
